module.exports = __webpack_public_path__ + "static/media/White.11152059.jpg";